export default __webpack_public_path__ + "static/image-3col-card-a4262f8fa571d76c3d418762918f6396.png";